import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeDeal } from 'bundles/apex/deals/show/store/deal/actions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons';

import { put } from 'helpers/api';

import StatusLabel from 'components/status_label';
import Card from 'bundles/apex/card';

import { Button } from 'components/ui/button';
import { faPlugCircleXmark } from '@fortawesome/pro-regular-svg-icons';

export const ListingHeader = ({ changeDeal, dealPath, isParentDeal, listing, project }) => {
  const source = isParentDeal ? project : listing;
  const handleDisconnect = async () => {
    const updatedDeal = await put(dealPath, { listingId: null });
    if (updatedDeal) return changeDeal(updatedDeal);
  };

  return (
    <Card className="listing-header" fullWidth>
      <div className="d-flex align-items-center">
        <div className="flex-grow-1">
          This deal is connected to Buildout Marketing.&nbsp;
          {!isParentDeal && (
            <span name="listing-status">
              The listing status is&nbsp;
              <b><StatusLabel.LabelAsSpan status={source.status} /></b>.
            </span>
          )}
        </div>
        {listing.userCanViewProject && (
          <div className="d-flex gap-1 align-items-center">
            <a className="btn btn-ghost" href={source.path} name="view">
              <FontAwesomeIcon icon={faEye} />
              <span name="view-label">View {isParentDeal ? 'Property' : 'Listing'}</span>
            </a>
            {!isParentDeal && (
              <Button
                icon={faPlugCircleXmark}
                name="disconnect"
                variant="ghost"
                onClick={handleDisconnect}
              >
                <span>Disconnect</span>
              </Button>
            )}
          </div>
        )}
      </div>
    </Card>
  );
};

ListingHeader.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  dealPath: PropTypes.string.isRequired,
  isParentDeal: PropTypes.bool,
  listing: PropTypes.shape({
    path: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }),
  project: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = ({ deal }) => ({
  dealPath: deal.path,
  isParentDeal: deal.parent,
  listing: deal.listing,
  project: deal.project
});

const mapDispatchToProps = { changeDeal };

export default connect(mapStateToProps, mapDispatchToProps)(ListingHeader);
